import useGameStore from '@/store';
import { useT } from '@/i18n/useLanguage';
import { Button, Portal } from '@chakra-ui/react';
import {
	MenuContent,
	MenuRadioItem,
	MenuRadioItemGroup,
	MenuPositioner,
	MenuRoot,
	MenuTrigger,
} from '@chakra-ui/react/menu';
import { useState } from 'react';
import { BiSolidChevronDown } from 'react-icons/bi';
import sortOrders from '../../data/orders-data';
import type { TranslationKey } from '@/i18n/translations';

const sortLabelKeys: Record<string, TranslationKey> = {
	'': 'relevance',
	'-added': 'dateAdded',
	name: 'name',
	'-release': 'releaseDate',
	'-metacritic': 'popularity',
	'-rating': 'averageRating',
};

const SortSelector = () => {
	const sortOrder = useGameStore((s) => s.gameQuery.sortOrder);
	const setSortOrder = useGameStore((s) => s.setSortOrder);
	const t = useT();

	const [value, setValue] = useState(sortOrder || '');
	const currentKey = sortLabelKeys[value] || 'relevance';

	return (
		<MenuRoot positioning={{ placement: 'bottom-start', gutter: 4 }}>
			<MenuTrigger asChild>
				<Button
					variant="outline"
					size="sm"
					rounded="md"
					borderColor="border"
					bg="bg.muted"
					fontWeight="600"
					_hover={{ borderColor: 'fg.muted' }}
				>
					{t('orderBy')}: {t(currentKey)}
					<BiSolidChevronDown />
				</Button>
			</MenuTrigger>
			<Portal>
				<MenuPositioner>
					<MenuContent
						minW="200px"
						rounded="lg"
						borderWidth="1px"
						borderColor="border"
						bg="bg.elevated"
						shadow="lg"
						py={1}
					>
						<MenuRadioItemGroup
							value={value}
							onValueChange={(e) => {
								setValue(e.value);
								setSortOrder(e.value);
							}}
						>
							{sortOrders.map((order) => (
								<MenuRadioItem key={order.value} value={order.value}>
									{t(sortLabelKeys[order.value] || 'relevance')}
								</MenuRadioItem>
							))}
						</MenuRadioItemGroup>
					</MenuContent>
				</MenuPositioner>
			</Portal>
		</MenuRoot>
	);
};

export default SortSelector;
